import { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../stores";
import { useParams } from "react-router";
import { Loader, Modal } from "../../../components";
import { EdnaChatType } from "../../../models/EdnaChat";
import Conversation from "../../../components/ednaConversations/Conversation";
import locale from "../../../constants/locale";
import { useTranslation } from "react-i18next";

const PrivateNotes = observer(
  ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const { t } = useTranslation();
    return (
      <Modal
        isLargeScreen
        isOpen={open}
        onClose={onClose}
        title={t(locale.notes)}
      >
        <PrivateNotesModal />
      </Modal>
    );
  }
);

const PrivateNotesModal = observer(() => {
  const { selectedChat } = useStore("chats");
  const { selectedWorkspace } = useStore("workspaces");
  const {
    findingChat,
    setWorkspaceId,
    firstOrCreateChat,
    chatInfo,
    setChatInfo,
  } = useStore("ednaChats");
  const [loadingChat, setLoadingChat] = useState(false);

  const { chatId } = useParams<{
    chatId?: string;
  }>();

  const getChat = useCallback(async () => {
    if (!selectedWorkspace?.id || !chatId || chatInfo?.id === chatId) return;

    setLoadingChat(true);

    const chatInformation = {
      name:
        (selectedChat?.firstName || "") + " " + (selectedChat?.lastName || ""),
      profileUrl: selectedChat?.image,
    };

    try {
      setChatInfo({
        id: chatId,
        type: EdnaChatType.CHATHUB_CHAT,
        ...chatInformation,
        extras: {},
      });

      const room = `chathub-chat-${chatId}`;
      setWorkspaceId(selectedWorkspace?.id);
      await firstOrCreateChat(EdnaChatType.CHATHUB_CHAT, room, chatInformation);
      setLoadingChat(false);
    } catch (error) {
      console.log("error", error);
    }
  }, [
    selectedWorkspace?.id,
    chatId,
    chatInfo?.id,
    selectedChat?.firstName,
    selectedChat?.lastName,
    selectedChat?.image,
    setChatInfo,
    setWorkspaceId,
    firstOrCreateChat,
  ]);

  useEffect(() => {
    getChat();
  }, [getChat]);

  return (
    <div
      className="is-relative w-100 is-flex"
      style={{
        height: "100%",
      }}
    >
      {loadingChat || findingChat ? (
        <div className="loaderClass">
          <Loader />
        </div>
      ) : (
        <Conversation hideHeader chatInfo={chatInfo} />
      )}
    </div>
  );
});

export default PrivateNotes;
